
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15A15 15 0 0018 3zm1.21 20.087c-1.133-.087-1.61-.667-2.5-1.19-.49 2.563-1.087 5.023-2.857 6.306-.546-3.876.8-6.786 1.427-9.876-1.067-1.797.13-5.414 2.38-4.524 2.77 1.097-2.4 6.667 1.073 7.38 3.624.73 5.104-6.286 2.857-8.57-3.247-3.293-9.45-.073-8.687 4.64.187 1.154 1.377 1.504.477 3.094-2.077-.46-2.697-2.1-2.617-4.284.13-3.576 3.214-6.08 6.307-6.426 3.913-.437 7.587 1.436 8.093 5.116.567 4.157-1.77 8.654-5.953 8.334z","fill":"currentColor"}})])
          )
        }
      }
    